import {
  LIST_CASHIER_REQUEST,
  LIST_CASHIER_SUCCESS,
  LIST_CASHIER_FAIL,
  DOWNLOAD_REGISTRATION_PATIENT_REQUEST,
  DOWNLOAD_REGISTRATION_PATIENT_SUCCESS,
  DOWNLOAD_REGISTRATION_PATIENT_FAIL,
  LIST_TRANSACTION_BY_TRANSACTION_ID_REQUEST,
  LIST_TRANSACTION_BY_TRANSACTION_ID_SUCCESS,
  LIST_TRANSACTION_BY_TRANSACTION_ID_FAIL,
  CREATE_BILLING_TRANSACTION_REQUEST,
  CREATE_BILLING_TRANSACTION_SUCCESS,
  CREATE_BILLING_TRANSACTION_FAIL,
  CANCEL_BILLING_TRANSACTION_REQUEST,
  CANCEL_BILLING_TRANSACTION_SUCCESS,
  CANCEL_BILLING_TRANSACTION_FAIL,
  DETAIL_TRANSACTION_BY_TRANSACTION_ID_REQUEST,
  DETAIL_TRANSACTION_BY_TRANSACTION_ID_SUCCESS,
  DETAIL_TRANSACTION_BY_TRANSACTION_ID_FAIL,
  DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_REQUEST,
  DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_SUCCESS,
  DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_FAIL,
  PRINT_INVOICE_PATIENT_REQUEST,
  PRINT_INVOICE_PATIENT_SUCCESS,
  PRINT_INVOICE_PATIENT_FAIL,
  FINISH_TRANSACTION_BY_ID_REQUEST,
  FINISH_TRANSACTION_BY_ID_SUCCESS,
  FINISH_TRANSACTION_BY_ID_FAIL,
  ADD_PAYMENT_TRANSACTION_REQUEST,
  ADD_PAYMENT_TRANSACTION_SUCCESS,
  ADD_PAYMENT_TRANSACTION_FAIL,
  CREATE_EXCESS_CASHIER_REQUEST,
  CREATE_EXCESS_CASHIER_SUCCESS,
  CREATE_EXCESS_CASHIER_FAIL,
  GET_EXCESS_CASHIER_REQUEST,
  GET_EXCESS_CASHIER_SUCCESS,
  GET_EXCESS_CASHIER_FAIL,
  DELETE_EXCESS_CASHIER_REQUEST,
  DELETE_EXCESS_CASHIER_SUCCESS,
  DELETE_EXCESS_CASHIER_FAIL,
  LIST_PROMO_SUMMARY_REQUEST,
  LIST_PROMO_SUMMARY_SUCCESS,
  LIST_PROMO_SUMMARY_FAIL,
  MEMBERSHIP_REGISTER_REQUEST,
  MEMBERSHIP_REGISTER_SUCCESS,
  MEMBERSHIP_REGISTER_FAIL
} from '../../constants/cashiers'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingCancel: false,
  loadingDelete: false,
  loadingPatchExcess: false,
  loadingGetExcess: false,
  loadingMembership: false,
  excess: {},
  cashiers: [],
  billingTransactions: [],
  productRegistrations: [],
  detailBillingTransaction: {},
  billingAdjustment: [],
  invoicePatient: {},
  promoSummary: [],
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listCashierReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_CASHIER_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_CASHIER_SUCCESS:
      return {
        ...state,
        loading: false,
        cashiers: action.payload,
        pageable: action.pageable
      }
    case LIST_CASHIER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        cashiers: action?.dummy
      }
    case DOWNLOAD_REGISTRATION_PATIENT_REQUEST:
      return {
        ...state,
        loadingDownload: true
      }
    case DOWNLOAD_REGISTRATION_PATIENT_SUCCESS:
      return {
        ...state,
        loadingDownload: false,
        error: null
      }
    case DOWNLOAD_REGISTRATION_PATIENT_FAIL:
      return {
        ...state,
        loadingDownload: false,
        error: action.payload
      }
    case LIST_TRANSACTION_BY_TRANSACTION_ID_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_TRANSACTION_BY_TRANSACTION_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        billingTransaction: action.payload,
        billingTransactions: action.payload?.billingTransactions,
        productRegistrations: action.payload?.registrationProducts,
        billingAdjustment: action.payload?.billingAdjustment,
        error: null
      }
    case LIST_TRANSACTION_BY_TRANSACTION_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        billingTransaction: action?.dummy,
        billingTransactions: action?.dummy.billingTransactions,
        productRegistrations: action?.dummy.registrationProducts
      }
    case CREATE_BILLING_TRANSACTION_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_BILLING_TRANSACTION_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        error: null
      }
    case CREATE_BILLING_TRANSACTION_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case CANCEL_BILLING_TRANSACTION_REQUEST:
      return {
        ...state,
        loadingCancel: true
      }
    case CANCEL_BILLING_TRANSACTION_SUCCESS:
      return {
        ...state,
        loadingCancel: false,
        error: null
      }
    case CANCEL_BILLING_TRANSACTION_FAIL:
      return {
        ...state,
        loadingCancel: false,
        error: action.payload
      }
    case DETAIL_TRANSACTION_BY_TRANSACTION_ID_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DETAIL_TRANSACTION_BY_TRANSACTION_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        detailBillingTransaction: action.payload,
        error: null
      }
    case DETAIL_TRANSACTION_BY_TRANSACTION_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        detailBillingTransaction: action?.dummy
      }
    case DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        error: null
      }
    case DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    case PRINT_INVOICE_PATIENT_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case PRINT_INVOICE_PATIENT_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        invoicePatient: action.payload,
        error: null
      }
    case PRINT_INVOICE_PATIENT_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        invoicePatient: {}
      }
    case FINISH_TRANSACTION_BY_ID_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case FINISH_TRANSACTION_BY_ID_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        error: null
      }
    case FINISH_TRANSACTION_BY_ID_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case ADD_PAYMENT_TRANSACTION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case ADD_PAYMENT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        error: null
      }
    case ADD_PAYMENT_TRANSACTION_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case MEMBERSHIP_REGISTER_REQUEST:
      return {
        ...state,
        loadingMembership: true
      }
    case MEMBERSHIP_REGISTER_SUCCESS:
      return {
        ...state,
        loadingMembership: false,
        error: null
      }
    case MEMBERSHIP_REGISTER_FAIL:
      return {
        ...state,
        loadingMembership: false,
        error: action.payload
      }
    case CREATE_EXCESS_CASHIER_REQUEST:
      return {
        ...state,
        loadingPatchExcess: true,
        error: null
      }
    case CREATE_EXCESS_CASHIER_SUCCESS:
      return {
        ...state,
        loadingPatchExcess: false,
        error: null
      }
    case CREATE_EXCESS_CASHIER_FAIL:
      return {
        ...state,
        loadingPatchExcess: false,
        error: action.payload
      }
    case GET_EXCESS_CASHIER_REQUEST:
      return {
        ...state,
        loadingGetExcess: true,
        excess: {},
        error: null
      }
    case GET_EXCESS_CASHIER_SUCCESS:
      return {
        ...state,
        loadingGetExcess: false,
        excess: action.payload,
        error: null
      }
    case GET_EXCESS_CASHIER_FAIL:
      return {
        ...state,
        loadingGetExcess: false,
        excess: {},
        error: action.payload
      }
    case DELETE_EXCESS_CASHIER_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        error: null
      }
    case DELETE_EXCESS_CASHIER_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        error: null
      }
    case DELETE_EXCESS_CASHIER_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    case LIST_PROMO_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_PROMO_SUMMARY_SUCCESS:
      return { ...state, loading: false, promoSummary: action.payload }
    case LIST_PROMO_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export default listCashierReducer
